import { SxProps } from '@mui/system';
import ThemeConstants from '../../../theme/ThemeConstants';

const classes = {

  legendContainerBg: (variant: string) =>
    ({
      backgroundColor: `pharmacist.${variant}Light`,
      padding: '5px 4px',
      borderRadius: '4px',
      justifyContent: 'space-evenly',
      alignItems: 'center',
    }),
  container: (variant) =>
    ({
      '&:hover': {
        opacity: 0.9,
        backgroundColor: `pharmacist.${variant}Light`,
        transform: 'scale(1.03)',
      },
    }),

  legendTitle: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: ThemeConstants.common.grey850,
  },

  legendTotalHrs: {
    fontSize: '0.875rem',
    fontWeight: 400,
    color: ThemeConstants.common.grey850,
  },

  legendTotalCount: {
    fontSize: '1rem',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2rem',
    height: '2rem',
    backgroundColor: 'secondary.main',
    borderRadius: '50%',
  },

  totalHrsCountColor: (variant: string) =>
    ({
      color: `pharmacist.${variant}`,
    }),

  totalCountContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  startContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
  },

  columnContainer: {
    flexDirection: 'column',
  },

} satisfies Record<string, SxProps<any>>;

export default classes;
